import {
	FCM_ENABLE_SUBSCRIPTIONS_FOR,
	FCM_MEMBERSHIP_ANNUAL_CONTRIBUTION,
	FCM_REVENUE_SUBS_ONE_TIME_CONTRIBUTIONS,
	FCM_SUBSCRIPTION_CONFIGURATION,
} from '@change-corgi/fcm/configs';

import { createFcmContext } from 'src/app/shared/contexts/fcm';
import type { LoadedStateData } from 'src/app/shared/utils/async';

export const {
	FcmContext: MembershipAwarenessFormFcmContext,
	FcmProvider: MembershipAwarenessFormFcmContextProvider,
	useFcm: useMembershipAwarenessFormFcm,
	useAsyncFcm: useAsyncMembershipAwarenessFormFcm,
	prefetchFcm: prefetchMembershipAwarenessFormFcm,
} = createFcmContext({
	name: 'MembershipAwarenessFormFcmContext',
	dataProperty: 'formFcm',
	configs: {
		membershipEnabled: FCM_ENABLE_SUBSCRIPTIONS_FOR,
		subscriptionConfig: FCM_SUBSCRIPTION_CONFIGURATION,
		yearlyContributionsAmounts: FCM_MEMBERSHIP_ANNUAL_CONTRIBUTION,
		oneTimeContributionsEnabled: FCM_REVENUE_SUBS_ONE_TIME_CONTRIBUTIONS,
	},
	prefetch: true,
});

export type MembershipAwarenessFormFcmState = ReturnType<typeof useAsyncMembershipAwarenessFormFcm>;
export type MembershipAwarenessFormFcm = LoadedStateData<MembershipAwarenessFormFcmState>;
